import { NavbarMenuContainer, NavbarMenuList, NavbarMenuListItem } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarMenu = {
  Container: NavbarMenuContainer,
  List: NavbarMenuList,
  ListItem: NavbarMenuListItem,
};
